
import { defineComponent, ref } from 'vue';
import Collapsible from '@/components/Collapsible.vue';
import EditModal from './EditModal.vue';
import { useRequestDataStore } from '@/store/request-data';
import { DrugSample } from '@/service/models/request/computation/drug-sample';
import ChartSettingsModal from '@/components/ChartSettingsModal.vue';
import ConcentrationChart from '@/components/ConcentrationChart.vue';
import { useChartsStore } from '@/store/charts';

export default defineComponent({
    components: {
        ChartSettingsModal,
        Collapsible,
        ConcentrationChart,
        EditModal,
    },

    setup()
    {
        const requestData = useRequestDataStore();
        const chartStore = useChartsStore();

        const isSampleModalOpen = ref(false);
        const isSettingsModalOpen = ref(false);
        const modalSampleIndex = ref(0);
        const modalData = ref<DrugSample|null>(null);

        function openSampleModal(sampleIndex: number|null): void
        {
            if (sampleIndex === null) {
                modalSampleIndex.value = requestData.samples.length;
                modalData.value = null;
            }
            else {
                modalSampleIndex.value = sampleIndex;
                modalData.value = requestData.samples[sampleIndex];
            }

            isSampleModalOpen.value = true;
        }

        function openSettingsModal(): void
        {
            isSettingsModalOpen.value = true;
        }

        function handleSave(payload: {index: number, data: DrugSample})
        {
            // Save data in the store
            requestData.samples[payload.index] = payload.data;
        }

        return {
            requestData,
            chartStore,
            openSampleModal, isSampleModalOpen, modalSampleIndex, modalData,
            handleSave,
            openSettingsModal, isSettingsModalOpen,
        };
    },
})
